/**
 * Single source of truth for Chleb AI's business identity facts: name, contact
 * details, address, founders, and social links.
 *
 * Every value here must already appear on the live site or in the repo.
 * Do not add a fact here that isn't traceable to an existing on-site
 * occurrence (see the 2026-09-05 entity-consistency audit).
 *
 * index.html's Organization JSON-LD and this module both use chleb@chleb.ai
 * (index.html was aligned on 2026-09-05; it previously said
 * info@chlebholdings.com). If the operator picks a different canonical
 * email, change it in both places.
 *
 * MANUAL SYNC NOTE: public/llms.txt is a static text file and cannot import
 * this module. If any value below changes (phone, email, address, social
 * links, founders), public/llms.txt's "Company" section must be updated by
 * hand to match.
 */

export const SITE_IDENTITY = {
  legalName: "Chleb Holdings LLC",
  brandName: "Chleb AI",
  url: "https://chleb.ai",
  email: "chleb@chleb.ai",
  phone: {
    display: "(813) 694-8671",
    e164: "+18136948671",
    tel: "tel:+18136948671",
    schema: "+1-813-694-8671",
  },
  address: {
    locality: "Tampa",
    region: "FL",
    country: "US",
  },
  areaServed: "United States",
  founders: [
    {
      name: "Dominik Kloda",
      linkedin: "https://www.linkedin.com/in/dominik-kloda/",
    },
    {
      name: "Jake Daly",
      linkedin: "https://www.linkedin.com/in/jakeadaly/",
    },
  ],
  social: {
    x: "https://x.com/Chlebai",
    linkedin: "https://www.linkedin.com/company/chleb-ai",
    instagram: "https://www.instagram.com/chleb.ai/",
  },
  // Google Business Profile created 2026-09-11 (place id ChIJ00CbRrGMnwARIhRnyxk41OE); the
  // Organization JSON-LD in index.html lists it under sameAs so the site, the profile and the
  // founders resolve to one entity. Public place URL only, no account or edit link.
  googleBusinessProfile: "https://www.google.com/maps/place/?q=place_id:ChIJ00CbRrGMnwARIhRnyxk41OE",
} as const;
